import { useQuery } from "@tanstack/react-query";
import { getProjectEditAccess } from "@/app/actions/project/edit-access/action";
import { QueryKey } from "@/app/vars/QueryKeys";

type Options = {
  projectId?: number;
  enabled?: boolean;
};

export function useFetchProjectEditAccess(options: Options) {
  const { projectId, enabled = true } = options;

  return useQuery({
    queryKey: [QueryKey.PROJECT_EDIT_ACCESS, projectId],
    queryFn: () => getProjectEditAccess(projectId!),
    enabled: enabled && !!projectId,
    staleTime: Infinity,
  });
}
